export default __webpack_public_path__ + "static/media/list-dark.7f5f35c1.svg";